// react import
import PropTypes from 'prop-types';

// ==============================|| TEXT HIGHLIGHT ||============================== //

/**
 * FileMngrTextHightlight component
 * @author Marcos L. A. Soto <marcosleonildo@gmail.com>
 * @param {string} text
 * @param {string} textToHighlight
 * @param {string} color
 * @returns {element} component
 */
const FileMngrTextHightlight = ({ text, textToHighlight, color }) => {
    const parts = text.split(new RegExp(`(${textToHighlight})`, 'gi'));
    return (
        <span>
            {parts.map((part, index) => (
                <span
                    key={index}
                    style={
                        part?.toLowerCase() === textToHighlight?.toLowerCase() ? { backgroundColor: color ?? 'yellow', color: 'black' } : {}
                    }
                >
                    {part}
                </span>
            ))}
        </span>
    );
};

FileMngrTextHightlight.propTypes = {
    text: PropTypes.string,
    textToHighlight: PropTypes.string,
    color: PropTypes.string
};

export default FileMngrTextHightlight;
